/*
 * @Author: HS
 * @Date: 2022-02-09 16:12:08
 * @LastEditors: DQL
 * @LastEditTime: 2022-06-25 10:13:58
 * @Description: file content
 */
const qjglRoutes = {
  path: 'qjgl',
  name: 'qjgl',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'qjsqAdd',
      name: 'qjsqAdd',
      component: () =>
        import(
          /* webpackChunkName: "qjsqAdd" */ '@/features/attendance/qxjgl/qjgl/qjsq.vue'
        ),
      meta: {
        navtabTitle: '请假申请',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'qjsq/:processInsId',
      name: 'qjsq',
      component: () =>
        import(
          /* webpackChunkName: "qjsq" */ '@/features/attendance/qxjgl/qjgl/qjsq.vue'
        ),
      meta: {
        navtabTitle: '请假申请',
        isCache: true,
        ignoreDiff: ['openFrom'],
        menuElements: []
      }
    },
    {
      path: 'qjsqBack/:processInsId/:condition',
      name: 'qjsqBack',
      component: () =>
        import(
          /* webpackChunkName: "qjsqBack" */ '@/features/attendance/qxjgl/qjgl/qjsq.vue'
        ),
      meta: {
        navtabTitle: '请假申请',
        isCache: true,
        ignoreDiff: ['openFrom'],
        menuElements: []
      }
    },
    {
      path: 'qjsqSp/:processInsId/:taskId',
      name: 'qjsqSp',
      component: () =>
        import(
          /* webpackChunkName: "qjsqSp" */ '@/features/attendance/qxjgl/qjgl/qjsqSp.vue'
        ),
      meta: {
        navtabTitle: '请假申请审批',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'qjsqSpResult/:processInsId/:taskId',
      name: 'qjsqSpResult',
      component: () =>
        import(
          /* webpackChunkName: "qjsqSpResult" */ '@/features/attendance/qxjgl/qjgl/qjsqSp.vue'
        ),
      meta: {
        navtabTitle: '请假申请审批',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'qjdmx/:processInsId/:taskId?',
      name: 'qjdmx',
      component: () =>
        import(
          /* webpackChunkName: "qjdmx" */ '@/features/attendance/qxjgl/qjgl/qjdmx.vue'
        ),
      meta: {
        navtabTitle: '请假申请明细',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    }
  ]

};
export default qjglRoutes;
